import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useLanguage } from '../../LanguageProvider';
import { initiateKlarnaPayment } from '../../services/PaymentService';
import './Payment.scss';

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { languageData } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [klarnaContainer, setKlarnaContainer] = useState(null);

  // Get registration data from state or sessionStorage
  const registrationData = location.state?.registrationData || 
    JSON.parse(sessionStorage.getItem('registrationData'));

  // Calculate price based on discipline
  const calculatePrice = (discipline) => {
    switch(discipline) {
      case 'Duathlon Einzel':
        return 25;
      case 'Duathlon Team':
        return 40;
      case 'Berglauf':
        return 20;
      case 'Mountainbike-Rennen':
        return 20;
      default:
        return 0;
    }
  };

  useEffect(() => {
    if (!registrationData) {
      navigate('/registration');
      return;
    }

    const loadKlarnaCheckout = async () => {
      try {
        setLoading(true);
        
        // Prepare payment data for Klarna
        const price = calculatePrice(registrationData.discipline);
        // const teamSize = registrationData.teamMembers.length;
        // const participantName = registrationData.teamMembers[0].firstName + ' ' + 
        //                        registrationData.teamMembers[0].lastName;
        
        console.log(price);
        console.log(registrationData.discipline);
        console.log(price * 100); // unit_price
        console.log(price * 0.2); // total_tax_amount


        const paymentData = {
          amount: price,
          currency: 'EUR',
          description: `Registration for ${registrationData.discipline}`,
          order_lines: [
            {
              name: registrationData.discipline,
              quantity: 1,
              unit_price: price * 100, // Klarna expects amounts in cents
              tax_rate: 2000,
              total_amount: price * 100,
              total_tax_amount: Math.round((price * 100 * 2000) / 12000), // 20% of price
            }
          ],
          customer: {
            email: registrationData.teamMembers[0].email,
            given_name: registrationData.teamMembers[0].firstName,
            family_name: registrationData.teamMembers[0].lastName
          }
        };
        
        // Call your backend to create Klarna payment session
        const response = await initiateKlarnaPayment(paymentData);
        
        // Set Klarna container HTML
        setKlarnaContainer(response.html_snippet);
        
        setLoading(false);
      } catch (err) {
        console.error('Payment initiation error:', err);
        setError(languageData.payment.initError);
        setLoading(false);
      }
    };

    loadKlarnaCheckout();
  }, [registrationData, navigate, languageData]);
  
  // Render Klarna container after it's loaded
  useEffect(() => {
    if (klarnaContainer) {
      // Create a container for Klarna checkout and inject the HTML
      const container = document.getElementById('klarna-checkout-container');
      if (container) {
        container.innerHTML = klarnaContainer;
      }
    }
  }, [klarnaContainer]);

  return (
    <>
      <Helmet>
        <title>
          {languageData.payment.pageTitle} - Unterberg Duathlon 2027
        </title>
        <meta
          name="description"
          content={languageData.payment.metaDescription}
        />
      </Helmet>
      <div className="payment">
        <div className="payment__container">
          <h2 className="payment__title">{languageData.payment.title}</h2>
          
          {loading ? (
            <div className="payment__loading">
              <p>{languageData.payment.loading}</p>
            </div>
          ) : error ? (
            <div className="payment__error">
              <p>{error}</p>
              <button 
                onClick={() => navigate('/registration')} 
                className="payment__back-btn"
              >
                {languageData.payment.backToRegistration}
              </button>
            </div>
          ) : (
            <>
              <div className="payment__details">
                <p>
                  <strong>{languageData.payment.discipline}:</strong> {registrationData.discipline}
                </p>
                <p>
                  <strong>{languageData.payment.amount}:</strong> {calculatePrice(registrationData.discipline)} €
                </p>
              </div>
              
              <div id="klarna-checkout-container" className="payment__klarna-container"></div>
              
              <div className="payment__actions">
                <button 
                  onClick={() => navigate('/participants')} 
                  className="payment__cancel-btn"
                >
                  {languageData.payment.cancel}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Payment;